import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import api from "@/lib/api";
import { formatApiError } from "@/lib/auth";

export default function MagicLink() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const [status, setStatus] = useState("verifying");
  const [error, setError] = useState("");
  const token = params.get("token");

  useEffect(() => {
    if (!token) {
      setStatus("error");
      setError("Missing token");
      return;
    }
    (async () => {
      try {
        await api.get(`/magic-link/verify?token=${encodeURIComponent(token)}`);
        setStatus("ok");
        setTimeout(() => nav("/portal"), 600);
      } catch (err) {
        setStatus("error");
        setError(formatApiError(err));
      }
    })();
  }, [token, nav]);

  return (
    <div className="min-h-screen flex items-center justify-center hero-gradient">
      <div className="bento p-10 max-w-md text-center" data-testid="magic-link-status">
        <img src="/logo-mark.png" alt="Foliosy" className="w-14 h-14 object-contain mx-auto mb-6" />
        {status === "verifying" && (
          <>
            <div className="w-10 h-10 rounded-full border-2 border-slate-900 border-t-transparent animate-spin mx-auto mb-4" />
            <h2 className="text-2xl font-bold mb-2">Verifying your link…</h2>
            <p className="text-slate-600">Hold tight, this takes a second.</p>
          </>
        )}
        {status === "ok" && (
          <>
            <div className="w-10 h-10 rounded-full bg-emerald-500 text-white flex items-center justify-center mx-auto mb-4">✓</div>
            <h2 className="text-2xl font-bold mb-2">You're in</h2>
            <p className="text-slate-600">Redirecting to your portal…</p>
          </>
        )}
        {status === "error" && (
          <>
            <div className="w-10 h-10 rounded-full bg-red-500 text-white flex items-center justify-center mx-auto mb-4">!</div>
            <h2 className="text-2xl font-bold mb-2">Link invalid</h2>
            <p className="text-slate-600" data-testid="magic-error-text">{error}</p>
            <p className="text-sm text-slate-400 mt-3">Ask your agency for a fresh link.</p>
          </>
        )}
      </div>
    </div>
  );
}
